<template>
  <div class='EnbNews'>
    <div class="text" :style="{ color: Prefes.frentelojaCorFonte.color }">ÚLTIMAS NOVIDADES</div>
    <div class="cont">
      <product-list
      v-for="(p, key) in news"
      :key="key"
      :data="p"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProductList from './ProductList'
export default {
  name: 'EnbNews',
  components: { ProductList },
  data () {
    return {
      news: []
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['GetProductNews'])
  },
  created () {
    this.GetProductNews()
      .then(res => {
        this.news = res
      })
  }
}
</script>

<style scoped>
.EnbNews {
  width: 100%;
  /* height: 100%; */
}

.text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: bold;
  width: 96%;
  padding: 2%;
}

.cont {
  width: 70%;
  /* height: 95%; */
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}

@media (max-width: 500px) {
  .cont {
    width: 100%;
  }
  
  .text {
    width: 90%;
    padding: 5%;
  }
}
</style>
